// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Styles for the sidebar and popup */

.mapsidebar {
  width: 62px; /* Set to a visible size */
  height: calc(100vh - 0px);/* Full height of viewport */
  position: fixed;
  top: 0;
  right: 0; /* Position on the right side */
  background-color: #000; /* Black background */
  padding: 10px;
  box-sizing: border-box;
  z-index: 1000; /* Ensure it's above other content */
  display: flex;
  flex-direction: column;
}
/* Main container for sidebar and map */
.map-sidebar-container {
  display: flex; /* Flexbox for layout */
  flex-direction: row-reverse; /* Sidebar on the right, map on the left */
  height: calc(100vh - 96px); /* Full height minus navbar */
  position: fixed; /* Fixed to the viewport */
  top: 96px; /* Below the navbar */
  left: 0;
  right: 0;
  width: 100vw; /* Full viewport width */
  overflow: hidden; /* Prevent overflow */
}

/* Sidebar styles */
.sidebar {
  width: 60px; /* Fixed sidebar width */
  background-color: #141313;
  box-shadow: -2px 0 5px rgba(24, 24, 24, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2px;
  z-index: 1000;
  position: relative; /* Relative positioning to stay within the layout */
  height: 100%; /* Full height */
}

/* Map container styles */
.map-container {
  flex-grow: 1; /* Let the map container take up all remaining space */
  margin: 0;
  padding: 0;
  height: 100%; /* Full height */
  position: relative; /* No need for absolute positioning */
}
.divider {
  height: 1px; /* Set the height of the divider */
  color: white;
  margin: 10px 0; /* Add some spacing above and below the line */
  width: 100%; /* Make the divider take full width */
  background-color: white; 
}


/* Responsive adjustments for small screens */
@media (max-width: 768px) {
  .sidebar {
    width: 40px; /* Reduce sidebar width for smaller screens */
  }


 .map-container {
    width: calc(100vw - 40px); /* Adjust map width for smaller sidebar */
  }
}

@media (max-width: 480px) {
  .map-container {
    width: 100vw;
    height: 100vh;
  }

  /* Adjust zoom controls to the top-left */
  .gmnoprint {
    top: 50px !important;
    left: 100px !important;
  }
}



/* Sidebar logo styling */
.sidebar-logo {
  width: 40px;
  height: 40px;
  margin: 20px 0;
  cursor: pinter;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;;
  border-radius: 8px; /* Rounded corners for better visual appeal */
  background-color: transparent;
}
.sidebar-logo:hover {
  transform: scale(1.1); /* Slight scaling on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow on hover */
}

.sidebar-logo.selected {
  background-color: hsl(45, 100%, 50%); /* Highlighted background color (blue) */
  transform: scale(1.15); /* Slightly larger when selected */
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.5); /* Blue glow for selected icon */
  border: none; /* Remove any border for a clean look */
}

/* Popup overlay styling */
.popup-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
display: flex;
justify-content: center;
align-items: center;
z-index: 2000; /* Ensure the popup is on top of everything */
}


/* Popup button container */
.popup-buttons {
display: flex;
justify-content: space-between;
margin-top: 10px;
}

/* Popup background click handler */
.popup-background {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
cursor: pointer;
}
/* Popup content styling */
.popup-content {
background: #fff;
padding: 30px; /* Increased padding for more space inside the popup */
border-radius: 8px;
width: 400px; /* Increased width */
box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
position: relative;
}

/* Field container styling */
.popup-field {
margin-bottom: 20px; /* Increased margin for better spacing */
display: flex; /* Flexbox for horizontal alignment */
align-items: center; /* Align items vertically */
}

/* Label styling */
.popup-field label {
flex: 0 0 100px; /* Fixed width for labels */
margin-right: 0px; /* Space between label and input */
font-weight: bold;
}

/* Input styling */
.popup-field input {
flex: 1 1; /* Take up remaining space */
padding: 10px; /* Increased padding for better input appearance */
border-radius: 4px;
border: 1px solid #ddd;
}

/* Additional CSS for displaying hover coordinates */
.coordinates-display {
position: absolute;
bottom: 10px;
right: 10px;
background-color: #fff;
padding: 5px;
border: 1px solid #ccc;
border-radius: 5px;
}

/* Style for the table row containing user type radio buttons */
.user-type-row {
  display: flex;
  align-items: center;
  gap: 15px; /* Space between radio buttons */
  padding: 10px 0; /* Space above and below the row */
}

/* Style for radio button labels */
.user-type-label {
  display: flex;
  align-items: center;
  font-size: 16px; /* Adjust font size as needed */
}

/* Style for radio button itself */
.user-type-input {
  margin-right: 8px; /* Space between radio button and label text */
}

/* Optional: Add some margin to the labels */
.user-type-label + .user-type-label {
  margin-left: 15px; /* Space between radio button labels */
}

.sidebar .menu-item {
  padding: 15px;
  margin-bottom: 10px;
  font-size: 18px;
  text-decoration: none;
  color: white;
  display: block;
  transition: background-color 0.3s ease;
}

.sidebar .menu-item:hover {
  background-color: #34495e;
}

/* Welcome Message Styling */
.welcome-message {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  background-color: #e1e9ed;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Link Styling */
.content p {
  font-size: 18px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, background-color 0.3s ease;
  cursor: pointer;
}

.content p:hover {
  transform: translateY(-2px);
  background-color: #e9f5ff;
}

.content a {
  text-decoration: none;
  color: #007bff;
  font-weight: 600;
}

.content a:hover {
  color: #0056b3;
}

/* Completed Step Styling */
.completed {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #28a745;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}

.completed-icon {
  margin-right: 5px;
  color: #28a745;
}

/* Loading State */
.loading {
  font-size: 18px;
  color: #666;
  text-align: center;
  padding: 50px;
}

/* Sidebar Styling */
.home-sidebar {
  width: 350px; /* Sidebar width */
  background: #f0f4f5;
  padding: 20px;
  height: 100vh;
  margin-left: 0px;
  margin-right: -100px;
}

/* Content Area Styling */
.home-content {
  margin-left: 20px; /* Padding between sidebar and content */
}

.home-heading {
  margin-bottom: 25px;
}

/* List Item Styling */
.sidebar-item {
  margin-bottom: 25px; /* Margin below each list item */
  text-align: center; /* Center-align text */
}

/* User Detail Page */

.user-profile-container {
  max-width: 1200px; /* Increased the width to 1200px */
  margin: 0 auto;
  padding: 20px;
  background-color: #c3c7c9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Heading styling */
.user-profile-container h1 {
  font-size: 34px;
  margin-bottom: 20px;
  color: #000000;
  font-weight: bold;
}

/* Table styling */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

/* Label (td) styling for the left column */
.table td:first-child {
  width: 30%;  /* Decrease the label column width */
  padding: 16px;
  font-weight: bold; /* Optionally make labels bold */
  text-align: left;
  background-color: #f8f9fa; /* Optional: Set a background color to distinguish */
  color: #555;
}

/* Data (td) styling for the right column */
.table td:last-child {
  width: 70%; /* Increase the data column width */
  padding: 16px;
  text-align: left;
  background-color: #f8f9fa;
  color: #333;
}
.table th {
  background-color: #f4f4f4;
  color: #555;
}

.table td {
  background-color: #fff;
  color: #333;
  padding-left: 50px;
}

/* Input and textarea styling */
input[type="text"],
textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
}

textarea {
  resize: vertical;
  min-height: 100px;
}

/* File input styling */
input[type="file"] {
  margin-top: 10px;
}

/* Alert message styling */
.alert {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert-info {
  background-color: #e9f5ff;
  color: #007bff;
}

/* Company logo styling */
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.logo-container img,
.logo-container svg {
  max-width: 100px;
  max-height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
  object-fit: cover;
}

.file-input {
  width: auto; /* Allow the input field to take its full size */
  font-size: 14px; /* Increase font size if needed */
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: visible; /* Ensure the full message is visible */
  margin-top: 10px;
}


.logo-container input[type="file"] {
  margin-top: 10px;
}

/* Radio button container styling */
.radio-buttons {
  margin-bottom: 20px;
}

.radio-buttons label {
  display: flex;
  align-items: center; /* Align items vertically center */
}

.radio-button-label input[type="radio"] {
  margin-right: 10px; /* Adjust the space as needed */
}

/* Ensure consistent button sizing */
.btn {
  padding: 10px 20px;    /* Adjust padding as needed */
  font-size: 16px;       /* Ensure consistent font size */
  border-radius: 4px;    /* Optional: same border radius for both buttons */
  min-width: 100px;      /* Ensure a minimum width for both buttons */
}

.button-group {
  display: flex;
  gap: 10px;             /* Space between buttons */
  margin-top: 15px;      /* Space above the button group */
}




/* End User Detail Page css*/

/* ProviderDetails.css */
body, html {
  height: 100%; /* Make sure the body and html take up the full height */
  margin: 0;
  padding: 0;
}

.provider-details-container {
  max-width: 900px;
  margin: auto; /* Center horizontally */
  padding: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background-color: #616567;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  font-family: 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center content vertically */
  align-items: center; /* Center content horizontally */
  min-height: 100vh; /* Ensure the container takes up the full height of the viewport */
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.company-logo {
  max-width: 120px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  color: #000000;
  font-weight: bold;
  margin-bottom: 30px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.detail-item {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: box-shadow 0.2s ease;
  overflow: hidden; /* Prevent content from overflowing */
}

.detail-item:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.detail-item strong {
  font-weight: bold;
  color: #555;
  margin-right: 20px; /* Space between label and data */
  white-space: nowrap; /* Prevent label from wrapping */
}

.detail-item .value {
  color: #f5f9fd;
  flex: 1 1; /* Allows the value to take up remaining space */
  overflow: hidden; /* Hide overflowed text */
  text-overflow: ellipsis; /* Add ellipsis for overflowed text */
  white-space: nowrap; /* Prevent wrapping */
}

.detail-item a {
  color: #1a73e8;
  text-decoration: none;
}

.detail-item a:hover {
  text-decoration: underline;
}

.no-user {
  text-align: center;
  font-size: 18px;
  color: #f00;
  margin-top: 50px;
}

@media (max-width: 600px) {
  .provider-details-container {
    padding: 15px;
  }

  .company-logo {
    max-width: 100px;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-item strong {
    margin-right: 0;
    margin-bottom: 5px; /* Space between label and data in column layout */
    white-space: normal; /* Allow label to wrap in column layout */
  }

  .detail-item .value {
    white-space: normal; /* Allow data to wrap in column layout */
  }
}

.contact-sales-button {
   margin-left: 200px;
  display: block;
  width: 50%;
  padding: 10px;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}



/* end ProviderDetails.css */
/* Contact sales form */
.contact-form-container {
  max-width: 900px;
  margin: -40px ; /* Adjust margin for spacing */
  padding: 10px;
  background-color: #616567;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add subtle shadow */
}

.contact-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 15px;
}

.heading-blue {
  color: #000000;
  font-weight: bold;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-button {
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  width: 100%; /* Full width for the button */
}

.loader-overlay {
  position: fixed; /* Changed from absolute to fixed */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8); /* Slightly more opaque background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's on top of all other content */
}

.page-container.loading {
  pointer-events: none; /* Disable interactions */
}
.no-space-top {
  padding-top: 0 !important; /* Remove top padding */
}

.page-container {
  margin: 0;
  padding: 0;
  min-height: 100vh; /* Ensure the page takes the full height */
}

/*end Contact sales form*/

/* Leads page */
.leads-table-body td:first-child {
  font-weight: normal; /* Remove bold from the first column */
  text-align: center;
}

.leads-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.leads-container {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.leads-heading {
  font-size: 2rem;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}

.leads-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  table-layout: fixed; /* Ensure columns have equal width */
}

.leads-table-header th {
  background-color: #343a40;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 12px;
  text-align: center;  /* Center-align table headers horizontally */
  vertical-align: middle;  /* Center-align table headers vertically */
}

.leads-table-body td {
  padding: 12px;
  font-size: 1rem;
  text-align: center;  /* Center text horizontally */
  vertical-align: middle;  /* Center text vertically */
  font-weight: normal; /* Ensure no bold text */
  word-wrap: break-word; /* Handle long text properly */
  overflow: hidden; /* Hide overflow */
  white-space: nowrap; /* Prevent line breaks */
  max-width: 150px; /* Set a maximum width for table cells */
  text-overflow: ellipsis; /* Add ellipsis for overflow text */
  position: relative; /* Position relative to contain absolute children */
}

.leads-table-body td .scrollable {
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent line breaks */
  max-width: 100%; /* Allow full width of the cell */
  display: inline-block; /* Allow scrolling to work */
}

.leads-table-body td:hover {
  overflow: visible; /* Show full content on hover */
}

.leads-table-body tr:hover {
  background-color: #f1f1f1;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .leads-heading {
    font-size: 1.5rem;
  }

  .leads-table-header th,
  .leads-table-body td {
    font-size: 0.875rem;
    padding: 8px;
  }
}
/* end Leads page css */

/*Dashboard css*/
.home-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  background-color: #a2a4a4;
  
}

.content {
  flex: 1 1;
  padding: 20px;
}

.step-container {
  display: block;
  width: 100%; /* Ensure it takes the full width of the parent */
  box-sizing: border-box; /* Include padding and border in the element's total width */
  padding: 10px; /* Add padding for better spacing */
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-bottom: 10px; /* Add space between steps */
}

.step-container > div {
  color: #007bff; /* Blue text */
  font-size: 18px;
  margin: 0;
}

.with-sidebar {
  margin-left: 200px; /* Adjust based on your sidebar width */
}

.completed-icon-container {
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.completed-icon {
  color: green; /* Green color for the check mark */
  margin-right: 8px;
}

.completed-text {
  color: green; /* Green color for the 'Completed' text */
  font-size: 16px;
  font-weight: bold;
}

.review-message {
  background-color: #c3c7c9;
  color: #045685;
  border: 1px solid #bee5eb;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.incomplete-message {
  background-color: #c3c7c9;
  color: #045685;
  border: 1px solid #bee5eb;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.partial-completion-message {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.step-container.completed {
  background-color: #e1e9ed;
  border-color: #5e99cf; 
}

/*end Dashboard css*/
/* services page css */
.services-container {
  margin-top: -40px;
  text-align: left;
  background-color:  #e1e9ed;
}

.services-heading {
  margin-bottom: 15px;
  color: #000000;
  font-weight: bold;
}

.checkbox-list {
  text-align: left;
  margin: 0 auto;
}

.service-checkbox {
  margin-bottom: 10px;
  font-size: 18px;
}

.service-checkbox input {
  margin-right: 10px;
}

.button-container {
  margin-top: 30px;
}

.select-drone-payload-button {
  font-size: 18px;
  padding: 10px 20px;
}
/* end  services page css */

/* Drone payload page */
.drone-payload-card {
  background-color: #c3c7c9;
  border-radius: 8px;
  padding: 20px;
  display: flex; /* Use flexbox for centering */
  flex-direction: column; /* Stack items vertically */
  align-items: center; /* Center items horizontally */
}

.drone-payload-heading {
  color: #000000;
  font-weight: bold;
  text-align: center;
}

.payload-textarea {
  width: 100%; /* Full width of the card */
  height: 300px;
  resize: none;
  background-color: #f8f9fa;
  box-sizing: border-box; /* Include padding and border in width calculation */
}

.word-count {
  position: absolute;
  bottom: 135px;
  right: 10px; /* Adjust to prevent overflow on smaller screens */
  font-size: 12px;
  color: gray;
  background-color: white;
  padding: 2px 4px;
  border-radius: 4px;
}

.submit-btn {
  width: 50%;
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 1.2rem;
}

/* Center the form submit button */
.text-center {
  text-align: center;
}

.alert {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .drone-payload-heading {
    font-size: 1.5rem;
  }

  .submit-btn {
    width: 100%;
  }
}

/* Add custom styling for the skip button */
.custom-skip-btn { 
  height: 105px;            /* Text color */
  margin-top: 20px;
}


/* End Drone payload page */

/* Terms and condations */
.terms-container {
  background-color: #c3c7c9;
  padding: 20px;
  min-height: 100vh; /* Make sure it takes full height */
}

.terms-heading {
  color: #000000;
  font-weight: bold;
  margin-bottom: 20px; /* Space below heading */
}

.terms-checkbox {
  display: flex;
  margin-bottom: 20px; /* Space below checkbox */
}

.button-container {
  display: flex;
  justify-content: center; /* Center the button */
}

.loading-spinner {
  position: fixed; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* end Terms and condations */
/* Buttons styling */
.btn-primary {
  background-color: #FC5C65; /* Primary button color */
  color: rgb(0, 0, 0);       /* Text color */
  font-size: large;
  border-radius: 40px;       /* Make corners rounded */
  border: none;              /* Remove border */
  outline: none;             /* Remove outline */
  cursor: pointer;           /* Change cursor to pointer */
  transition: background-color 0.3s ease; /* Smooth transition */
  padding: 25px;
}

.btn-primary:hover {
  background-color: #FC5C65; /* Darker shade for hover */
  color: rgb(0, 0, 0);       /* Maintain text color */
}

.btn-primary:focus,
.btn-primary:active {
  background-color: #FC5C65; /* Maintain color on focus and active */
  color: rgb(0, 0, 0);       /* Maintain text color */
  outline: none;             /* Remove blue outline */
}

/* Fixing the disabled state to keep the color consistent */
.btn-primary:disabled {
  background-color: #FC5C65; /* Maintain button color when disabled */
  color: rgb(0, 0, 0);       /* Maintain text color */
  opacity: 0.7;              /* Slightly faded to indicate disabled */
  cursor: not-allowed;       /* Change cursor to not-allowed */
}

/* Secondary Button */
.btn-secondary {
  background-color: #6c757d; /* Secondary button color */
  color: #070707;            /* Text color */
  border-radius: 40px;       /* Make corners rounded */
  border: none;              /* Remove border */
  outline: none;             /* Remove outline */
  cursor: pointer;           /* Change cursor to pointer */
  transition: background-color 0.3s ease; /* Smooth transition */
  padding: 25px;
  font-size: large;
}

.btn-secondary:hover {
  background-color: #5a6268; /* Darker shade for hover */
}

.btn-secondary:focus,
.btn-secondary:active {
  background-color: #6c757d; /* Maintain color on focus and active */
  color: #0b0b0b;            /* Maintain text color */
  outline: none;             /* Remove blue outline */
}

.btn-secondary:disabled {
  background-color: #6c757d; /* Maintain button color when disabled */
  color: #070707;            /* Maintain text color */
  opacity: 0.7;              /* Slightly faded to indicate disabled */
  cursor: not-allowed;       /* Change cursor to not-allowed */
}


.container{
  background-color:rgb(201, 203, 207);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,qCAAqC;;AAErC;EACE,WAAW,EAAE,0BAA0B;EACvC,yBAAyB,CAAC,4BAA4B;EACtD,eAAe;EACf,MAAM;EACN,QAAQ,EAAE,+BAA+B;EACzC,sBAAsB,EAAE,qBAAqB;EAC7C,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,oCAAoC;EACnD,aAAa;EACb,sBAAsB;AACxB;AACA,uCAAuC;AACvC;EACE,aAAa,EAAE,uBAAuB;EACtC,2BAA2B,EAAE,0CAA0C;EACvE,0BAA0B,EAAE,6BAA6B;EACzD,eAAe,EAAE,0BAA0B;EAC3C,SAAS,EAAE,qBAAqB;EAChC,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,wBAAwB;EACtC,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA,mBAAmB;AACnB;EACE,WAAW,EAAE,wBAAwB;EACrC,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,kBAAkB,EAAE,mDAAmD;EACvE,YAAY,EAAE,gBAAgB;AAChC;;AAEA,yBAAyB;AACzB;EACE,YAAY,EAAE,sDAAsD;EACpE,SAAS;EACT,UAAU;EACV,YAAY,EAAE,gBAAgB;EAC9B,kBAAkB,EAAE,qCAAqC;AAC3D;AACA;EACE,WAAW,EAAE,kCAAkC;EAC/C,YAAY;EACZ,cAAc,EAAE,8CAA8C;EAC9D,WAAW,EAAE,qCAAqC;EAClD,uBAAuB;AACzB;;;AAGA,6CAA6C;AAC7C;EACE;IACE,WAAW,EAAE,6CAA6C;EAC5D;;;CAGD;IACG,yBAAyB,EAAE,yCAAyC;EACtE;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF;;;;AAIA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iFAAiF;EACjF,kBAAkB,EAAE,6CAA6C;EACjE,6BAA6B;AAC/B;AACA;EACE,qBAAqB,EAAE,4BAA4B;EACnD,wCAAwC,EAAE,2BAA2B;AACvE;;AAEA;EACE,oCAAoC,EAAE,wCAAwC;EAC9E,sBAAsB,EAAE,kCAAkC;EAC1D,6CAA6C,EAAE,gCAAgC;EAC/E,YAAY,EAAE,uCAAuC;AACvD;;AAEA,0BAA0B;AAC1B;AACA,eAAe;AACf,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,8BAA8B,EAAE,gCAAgC;AAChE,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,aAAa,EAAE,6CAA6C;AAC5D;;;AAGA,2BAA2B;AAC3B;AACA,aAAa;AACb,8BAA8B;AAC9B,gBAAgB;AAChB;;AAEA,mCAAmC;AACnC;AACA,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,eAAe;AACf;AACA,0BAA0B;AAC1B;AACA,gBAAgB;AAChB,aAAa,EAAE,sDAAsD;AACrE,kBAAkB;AAClB,YAAY,EAAE,oBAAoB;AAClC,yCAAyC;AACzC,kBAAkB;AAClB;;AAEA,4BAA4B;AAC5B;AACA,mBAAmB,EAAE,wCAAwC;AAC7D,aAAa,EAAE,qCAAqC;AACpD,mBAAmB,EAAE,2BAA2B;AAChD;;AAEA,kBAAkB;AAClB;AACA,eAAe,EAAE,2BAA2B;AAC5C,iBAAiB,EAAE,kCAAkC;AACrD,iBAAiB;AACjB;;AAEA,kBAAkB;AAClB;AACA,SAAO,EAAE,4BAA4B;AACrC,aAAa,EAAE,kDAAkD;AACjE,kBAAkB;AAClB,sBAAsB;AACtB;;AAEA,oDAAoD;AACpD;AACA,kBAAkB;AAClB,YAAY;AACZ,WAAW;AACX,sBAAsB;AACtB,YAAY;AACZ,sBAAsB;AACtB,kBAAkB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,gCAAgC;EAC3C,eAAe,EAAE,kCAAkC;AACrD;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,+BAA+B;AAClD;;AAEA,kCAAkC;AAClC;EACE,iBAAiB,EAAE,8CAA8C;AACnE;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,YAAY,EAAE,kBAAkB;EAChC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB,EAAE,gCAAgC;EACrD,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB,EAAE,kCAAkC;EACrD,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,UAAU,GAAG,oCAAoC;EACjD,aAAa;EACb,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;EAChB,yBAAyB,EAAE,oDAAoD;EAC/E,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,UAAU,EAAE,mCAAmC;EAC/C,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,gDAAgD;EAC7D,eAAe,EAAE,iCAAiC;EAClD,mBAAmB,EAAE,+BAA+B;EACpD,iBAAiB,EAAE,uCAAuC;EAC1D,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;AACrD;;AAEA,oCAAoC;AACpC;EACE,kBAAkB,KAAK,6BAA6B;EACpD,eAAe,QAAQ,gCAAgC;EACvD,kBAAkB,KAAK,kDAAkD;EACzE,gBAAgB,OAAO,4CAA4C;AACrE;;AAEA;EACE,aAAa;EACb,SAAS,cAAc,0BAA0B;EACjD,gBAAgB,OAAO,iCAAiC;AAC1D;;;;;AAKA,4BAA4B;;AAE5B,wBAAwB;AACxB;EACE,YAAY,EAAE,wDAAwD;EACtE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY,EAAE,wBAAwB;EACtC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,8BAA8B;EACvD,mBAAmB,EAAE,gCAAgC;EACrD,iBAAiB,EAAE,kEAAkE;AACvF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB,EAAE,iCAAiC;EACrD,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,cAAc;EACd,SAAO,EAAE,gDAAgD;EACzD,gBAAgB,EAAE,yBAAyB;EAC3C,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB,EAAE,kDAAkD;IACtE,mBAAmB,EAAE,yCAAyC;EAChE;;EAEA;IACE,mBAAmB,EAAE,wCAAwC;EAC/D;AACF;;AAEA;GACG,kBAAkB;EACnB,cAAc;EACd,UAAU;EACV,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;;;AAIA,4BAA4B;AAC5B,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc,EAAE,8BAA8B;EAC9C,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC,EAAE,sBAAsB;AAClE;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,eAAe,EAAE,mCAAmC;EACpD,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C,EAAE,oCAAoC;EAChF,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,4CAA4C;AAC7D;;AAEA;EACE,oBAAoB,EAAE,yBAAyB;AACjD;AACA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA,yBAAyB;;AAEzB,eAAe;AACf;EACE,mBAAmB,EAAE,sCAAsC;EAC3D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB,GAAG,4CAA4C;EACjE,sBAAsB,GAAG,0CAA0C;AACrE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB,GAAG,6BAA6B;EAClD,sBAAsB,GAAG,2BAA2B;EACpD,mBAAmB,EAAE,wBAAwB;EAC7C,qBAAqB,EAAE,8BAA8B;EACrD,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB,EAAE,wBAAwB;EAC7C,gBAAgB,EAAE,wCAAwC;EAC1D,uBAAuB,EAAE,mCAAmC;EAC5D,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,mBAAmB,EAAE,wBAAwB;EAC7C,eAAe,EAAE,iCAAiC;EAClD,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;AACF;AACA,uBAAuB;;AAEvB,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;;AAE3B;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,iDAAiD;EAC9D,sBAAsB,EAAE,4DAA4D;EACpF,aAAa,EAAE,mCAAmC;EAClD,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY,EAAE,mCAAmC;EACjD,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,yCAAyC;EACvD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA,2BAA2B;;AAE3B,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB,EAAE,2BAA2B;EACnD,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,sBAAsB,EAAE,oDAAoD;AAC9E;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE,kDAAkD;EAC/D,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa,aAAa,eAAe;EACzC,gBAAgB;AAClB;;;AAGA,2BAA2B;;AAE3B,yBAAyB;AACzB;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,sBAAsB;AACjD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,6BAA6B;AAC7B,oBAAoB;AACpB;EACE,yBAAyB,EAAE,yBAAyB;EACpD,mBAAmB,QAAQ,eAAe;EAC1C,gBAAgB;EAChB,mBAAmB,QAAQ,yBAAyB;EACpD,YAAY,eAAe,kBAAkB;EAC7C,aAAa,cAAc,mBAAmB;EAC9C,eAAe,YAAY,6BAA6B;EACxD,sCAAsC,EAAE,sBAAsB;EAC9D,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,mBAAmB,QAAQ,wBAAwB;AACrD;;AAEA;;EAEE,yBAAyB,EAAE,uCAAuC;EAClE,mBAAmB,QAAQ,wBAAwB;EACnD,aAAa,cAAc,wBAAwB;AACrD;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB,EAAE,wCAAwC;EACnE,mBAAmB,QAAQ,wBAAwB;EACnD,YAAY,eAAe,wCAAwC;EACnE,mBAAmB,QAAQ,iCAAiC;AAC9D;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,2BAA2B;EACtD,cAAc,aAAa,eAAe;EAC1C,mBAAmB,QAAQ,yBAAyB;EACpD,YAAY,eAAe,kBAAkB;EAC7C,aAAa,cAAc,mBAAmB;EAC9C,eAAe,YAAY,6BAA6B;EACxD,sCAAsC,EAAE,sBAAsB;EAC9D,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;;EAEE,yBAAyB,EAAE,uCAAuC;EAClE,cAAc,aAAa,wBAAwB;EACnD,aAAa,cAAc,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc,aAAa,wBAAwB;EACnD,YAAY,eAAe,wCAAwC;EACnE,mBAAmB,QAAQ,iCAAiC;AAC9D;;;AAGA;EACE,mCAAmC;AACrC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Styles for the sidebar and popup */\n\n.mapsidebar {\n  width: 62px; /* Set to a visible size */\n  height: calc(100vh - 0px);/* Full height of viewport */\n  position: fixed;\n  top: 0;\n  right: 0; /* Position on the right side */\n  background-color: #000; /* Black background */\n  padding: 10px;\n  box-sizing: border-box;\n  z-index: 1000; /* Ensure it's above other content */\n  display: flex;\n  flex-direction: column;\n}\n/* Main container for sidebar and map */\n.map-sidebar-container {\n  display: flex; /* Flexbox for layout */\n  flex-direction: row-reverse; /* Sidebar on the right, map on the left */\n  height: calc(100vh - 96px); /* Full height minus navbar */\n  position: fixed; /* Fixed to the viewport */\n  top: 96px; /* Below the navbar */\n  left: 0;\n  right: 0;\n  width: 100vw; /* Full viewport width */\n  overflow: hidden; /* Prevent overflow */\n}\n\n/* Sidebar styles */\n.sidebar {\n  width: 60px; /* Fixed sidebar width */\n  background-color: #141313;\n  box-shadow: -2px 0 5px rgba(24, 24, 24, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 2px;\n  z-index: 1000;\n  position: relative; /* Relative positioning to stay within the layout */\n  height: 100%; /* Full height */\n}\n\n/* Map container styles */\n.map-container {\n  flex-grow: 1; /* Let the map container take up all remaining space */\n  margin: 0;\n  padding: 0;\n  height: 100%; /* Full height */\n  position: relative; /* No need for absolute positioning */\n}\n.divider {\n  height: 1px; /* Set the height of the divider */\n  color: white;\n  margin: 10px 0; /* Add some spacing above and below the line */\n  width: 100%; /* Make the divider take full width */\n  background-color: white; \n}\n\n\n/* Responsive adjustments for small screens */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 40px; /* Reduce sidebar width for smaller screens */\n  }\n\n\n .map-container {\n    width: calc(100vw - 40px); /* Adjust map width for smaller sidebar */\n  }\n}\n\n@media (max-width: 480px) {\n  .map-container {\n    width: 100vw;\n    height: 100vh;\n  }\n\n  /* Adjust zoom controls to the top-left */\n  .gmnoprint {\n    top: 50px !important;\n    left: 100px !important;\n  }\n}\n\n\n\n/* Sidebar logo styling */\n.sidebar-logo {\n  width: 40px;\n  height: 40px;\n  margin: 20px 0;\n  cursor: pinter;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;;\n  border-radius: 8px; /* Rounded corners for better visual appeal */\n  background-color: transparent;\n}\n.sidebar-logo:hover {\n  transform: scale(1.1); /* Slight scaling on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow on hover */\n}\n\n.sidebar-logo.selected {\n  background-color: hsl(45, 100%, 50%); /* Highlighted background color (blue) */\n  transform: scale(1.15); /* Slightly larger when selected */\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.5); /* Blue glow for selected icon */\n  border: none; /* Remove any border for a clean look */\n}\n\n/* Popup overlay styling */\n.popup-overlay {\nposition: fixed;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\nbackground: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nz-index: 2000; /* Ensure the popup is on top of everything */\n}\n\n\n/* Popup button container */\n.popup-buttons {\ndisplay: flex;\njustify-content: space-between;\nmargin-top: 10px;\n}\n\n/* Popup background click handler */\n.popup-background {\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\ncursor: pointer;\n}\n/* Popup content styling */\n.popup-content {\nbackground: #fff;\npadding: 30px; /* Increased padding for more space inside the popup */\nborder-radius: 8px;\nwidth: 400px; /* Increased width */\nbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\nposition: relative;\n}\n\n/* Field container styling */\n.popup-field {\nmargin-bottom: 20px; /* Increased margin for better spacing */\ndisplay: flex; /* Flexbox for horizontal alignment */\nalign-items: center; /* Align items vertically */\n}\n\n/* Label styling */\n.popup-field label {\nflex: 0 0 100px; /* Fixed width for labels */\nmargin-right: 0px; /* Space between label and input */\nfont-weight: bold;\n}\n\n/* Input styling */\n.popup-field input {\nflex: 1; /* Take up remaining space */\npadding: 10px; /* Increased padding for better input appearance */\nborder-radius: 4px;\nborder: 1px solid #ddd;\n}\n\n/* Additional CSS for displaying hover coordinates */\n.coordinates-display {\nposition: absolute;\nbottom: 10px;\nright: 10px;\nbackground-color: #fff;\npadding: 5px;\nborder: 1px solid #ccc;\nborder-radius: 5px;\n}\n\n/* Style for the table row containing user type radio buttons */\n.user-type-row {\n  display: flex;\n  align-items: center;\n  gap: 15px; /* Space between radio buttons */\n  padding: 10px 0; /* Space above and below the row */\n}\n\n/* Style for radio button labels */\n.user-type-label {\n  display: flex;\n  align-items: center;\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n/* Style for radio button itself */\n.user-type-input {\n  margin-right: 8px; /* Space between radio button and label text */\n}\n\n/* Optional: Add some margin to the labels */\n.user-type-label + .user-type-label {\n  margin-left: 15px; /* Space between radio button labels */\n}\n\n.sidebar .menu-item {\n  padding: 15px;\n  margin-bottom: 10px;\n  font-size: 18px;\n  text-decoration: none;\n  color: white;\n  display: block;\n  transition: background-color 0.3s ease;\n}\n\n.sidebar .menu-item:hover {\n  background-color: #34495e;\n}\n\n/* Welcome Message Styling */\n.welcome-message {\n  font-size: 32px;\n  color: #333;\n  font-weight: bold;\n  margin-bottom: 30px;\n  text-align: center;\n  background-color: #e1e9ed;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Link Styling */\n.content p {\n  font-size: 18px;\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  cursor: pointer;\n}\n\n.content p:hover {\n  transform: translateY(-2px);\n  background-color: #e9f5ff;\n}\n\n.content a {\n  text-decoration: none;\n  color: #007bff;\n  font-weight: 600;\n}\n\n.content a:hover {\n  color: #0056b3;\n}\n\n/* Completed Step Styling */\n.completed {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  color: #28a745;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 10px;\n}\n\n.completed-icon {\n  margin-right: 5px;\n  color: #28a745;\n}\n\n/* Loading State */\n.loading {\n  font-size: 18px;\n  color: #666;\n  text-align: center;\n  padding: 50px;\n}\n\n/* Sidebar Styling */\n.home-sidebar {\n  width: 350px; /* Sidebar width */\n  background: #f0f4f5;\n  padding: 20px;\n  height: 100vh;\n  margin-left: 0px;\n  margin-right: -100px;\n}\n\n/* Content Area Styling */\n.home-content {\n  margin-left: 20px; /* Padding between sidebar and content */\n}\n\n.home-heading {\n  margin-bottom: 25px;\n}\n\n/* List Item Styling */\n.sidebar-item {\n  margin-bottom: 25px; /* Margin below each list item */\n  text-align: center; /* Center-align text */\n}\n\n/* User Detail Page */\n\n.user-profile-container {\n  max-width: 1200px; /* Increased the width to 1200px */\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #c3c7c9;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Heading styling */\n.user-profile-container h1 {\n  font-size: 34px;\n  margin-bottom: 20px;\n  color: #000000;\n  font-weight: bold;\n}\n\n/* Table styling */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n/* Label (td) styling for the left column */\n.table td:first-child {\n  width: 30%;  /* Decrease the label column width */\n  padding: 16px;\n  font-weight: bold; /* Optionally make labels bold */\n  text-align: left;\n  background-color: #f8f9fa; /* Optional: Set a background color to distinguish */\n  color: #555;\n}\n\n/* Data (td) styling for the right column */\n.table td:last-child {\n  width: 70%; /* Increase the data column width */\n  padding: 16px;\n  text-align: left;\n  background-color: #f8f9fa;\n  color: #333;\n}\n.table th {\n  background-color: #f4f4f4;\n  color: #555;\n}\n\n.table td {\n  background-color: #fff;\n  color: #333;\n  padding-left: 50px;\n}\n\n/* Input and textarea styling */\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\ntextarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* File input styling */\ninput[type=\"file\"] {\n  margin-top: 10px;\n}\n\n/* Alert message styling */\n.alert {\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.alert-info {\n  background-color: #e9f5ff;\n  color: #007bff;\n}\n\n/* Company logo styling */\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.logo-container img,\n.logo-container svg {\n  max-width: 100px;\n  max-height: 100px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.file-input {\n  width: auto; /* Allow the input field to take its full size */\n  font-size: 14px; /* Increase font size if needed */\n  white-space: nowrap; /* Prevent text from wrapping */\n  overflow: visible; /* Ensure the full message is visible */\n  margin-top: 10px;\n}\n\n\n.logo-container input[type=\"file\"] {\n  margin-top: 10px;\n}\n\n/* Radio button container styling */\n.radio-buttons {\n  margin-bottom: 20px;\n}\n\n.radio-buttons label {\n  display: flex;\n  align-items: center; /* Align items vertically center */\n}\n\n.radio-button-label input[type=\"radio\"] {\n  margin-right: 10px; /* Adjust the space as needed */\n}\n\n/* Ensure consistent button sizing */\n.btn {\n  padding: 10px 20px;    /* Adjust padding as needed */\n  font-size: 16px;       /* Ensure consistent font size */\n  border-radius: 4px;    /* Optional: same border radius for both buttons */\n  min-width: 100px;      /* Ensure a minimum width for both buttons */\n}\n\n.button-group {\n  display: flex;\n  gap: 10px;             /* Space between buttons */\n  margin-top: 15px;      /* Space above the button group */\n}\n\n\n\n\n/* End User Detail Page css*/\n\n/* ProviderDetails.css */\nbody, html {\n  height: 100%; /* Make sure the body and html take up the full height */\n  margin: 0;\n  padding: 0;\n}\n\n.provider-details-container {\n  max-width: 900px;\n  margin: auto; /* Center horizontally */\n  padding: 30px;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  background-color: #616567;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  font-family: 'Roboto', sans-serif;\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Center content vertically */\n  align-items: center; /* Center content horizontally */\n  min-height: 100vh; /* Ensure the container takes up the full height of the viewport */\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 25px;\n}\n\n.company-logo {\n  max-width: 120px;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n  text-align: center;\n  color: #000000;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.detail-item {\n  background-color: #ffffff;\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: box-shadow 0.2s ease;\n  overflow: hidden; /* Prevent content from overflowing */\n}\n\n.detail-item:hover {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n}\n\n.detail-item strong {\n  font-weight: bold;\n  color: #555;\n  margin-right: 20px; /* Space between label and data */\n  white-space: nowrap; /* Prevent label from wrapping */\n}\n\n.detail-item .value {\n  color: #f5f9fd;\n  flex: 1; /* Allows the value to take up remaining space */\n  overflow: hidden; /* Hide overflowed text */\n  text-overflow: ellipsis; /* Add ellipsis for overflowed text */\n  white-space: nowrap; /* Prevent wrapping */\n}\n\n.detail-item a {\n  color: #1a73e8;\n  text-decoration: none;\n}\n\n.detail-item a:hover {\n  text-decoration: underline;\n}\n\n.no-user {\n  text-align: center;\n  font-size: 18px;\n  color: #f00;\n  margin-top: 50px;\n}\n\n@media (max-width: 600px) {\n  .provider-details-container {\n    padding: 15px;\n  }\n\n  .company-logo {\n    max-width: 100px;\n  }\n\n  .detail-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .detail-item strong {\n    margin-right: 0;\n    margin-bottom: 5px; /* Space between label and data in column layout */\n    white-space: normal; /* Allow label to wrap in column layout */\n  }\n\n  .detail-item .value {\n    white-space: normal; /* Allow data to wrap in column layout */\n  }\n}\n\n.contact-sales-button {\n   margin-left: 200px;\n  display: block;\n  width: 50%;\n  padding: 10px;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n\n\n/* end ProviderDetails.css */\n/* Contact sales form */\n.contact-form-container {\n  max-width: 900px;\n  margin: -40px ; /* Adjust margin for spacing */\n  padding: 10px;\n  background-color: #616567;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add subtle shadow */\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.heading-blue {\n  color: #000000;\n  font-weight: bold;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.submit-button {\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  width: 100%; /* Full width for the button */\n}\n\n.loader-overlay {\n  position: fixed; /* Changed from absolute to fixed */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8); /* Slightly more opaque background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Ensure it's on top of all other content */\n}\n\n.page-container.loading {\n  pointer-events: none; /* Disable interactions */\n}\n.no-space-top {\n  padding-top: 0 !important; /* Remove top padding */\n}\n\n.page-container {\n  margin: 0;\n  padding: 0;\n  min-height: 100vh; /* Ensure the page takes the full height */\n}\n\n/*end Contact sales form*/\n\n/* Leads page */\n.leads-table-body td:first-child {\n  font-weight: normal; /* Remove bold from the first column */\n  text-align: center;\n}\n\n.leads-loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.leads-container {\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.leads-heading {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.leads-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  table-layout: fixed; /* Ensure columns have equal width */\n}\n\n.leads-table-header th {\n  background-color: #343a40;\n  color: white;\n  font-weight: 600;\n  font-size: 1.1rem;\n  padding: 12px;\n  text-align: center;  /* Center-align table headers horizontally */\n  vertical-align: middle;  /* Center-align table headers vertically */\n}\n\n.leads-table-body td {\n  padding: 12px;\n  font-size: 1rem;\n  text-align: center;  /* Center text horizontally */\n  vertical-align: middle;  /* Center text vertically */\n  font-weight: normal; /* Ensure no bold text */\n  word-wrap: break-word; /* Handle long text properly */\n  overflow: hidden; /* Hide overflow */\n  white-space: nowrap; /* Prevent line breaks */\n  max-width: 150px; /* Set a maximum width for table cells */\n  text-overflow: ellipsis; /* Add ellipsis for overflow text */\n  position: relative; /* Position relative to contain absolute children */\n}\n\n.leads-table-body td .scrollable {\n  overflow-x: auto; /* Enable horizontal scrolling */\n  white-space: nowrap; /* Prevent line breaks */\n  max-width: 100%; /* Allow full width of the cell */\n  display: inline-block; /* Allow scrolling to work */\n}\n\n.leads-table-body td:hover {\n  overflow: visible; /* Show full content on hover */\n}\n\n.leads-table-body tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 768px) {\n  .leads-heading {\n    font-size: 1.5rem;\n  }\n\n  .leads-table-header th,\n  .leads-table-body td {\n    font-size: 0.875rem;\n    padding: 8px;\n  }\n}\n/* end Leads page css */\n\n/*Dashboard css*/\n.home-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  background-color: #a2a4a4;\n  \n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n}\n\n.step-container {\n  display: block;\n  width: 100%; /* Ensure it takes the full width of the parent */\n  box-sizing: border-box; /* Include padding and border in the element's total width */\n  padding: 10px; /* Add padding for better spacing */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  margin-bottom: 10px; /* Add space between steps */\n}\n\n.step-container > div {\n  color: #007bff; /* Blue text */\n  font-size: 18px;\n  margin: 0;\n}\n\n.with-sidebar {\n  margin-left: 200px; /* Adjust based on your sidebar width */\n}\n\n.completed-icon-container {\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n}\n\n.completed-icon {\n  color: green; /* Green color for the check mark */\n  margin-right: 8px;\n}\n\n.completed-text {\n  color: green; /* Green color for the 'Completed' text */\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.review-message {\n  background-color: #c3c7c9;\n  color: #045685;\n  border: 1px solid #bee5eb;\n  border-radius: 5px;\n  padding: 15px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.incomplete-message {\n  background-color: #c3c7c9;\n  color: #045685;\n  border: 1px solid #bee5eb;\n  border-radius: 5px;\n  padding: 15px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.partial-completion-message {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n  border-radius: 5px;\n  padding: 15px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.step-container.completed {\n  background-color: #e1e9ed;\n  border-color: #5e99cf; \n}\n\n/*end Dashboard css*/\n/* services page css */\n.services-container {\n  margin-top: -40px;\n  text-align: left;\n  background-color:  #e1e9ed;\n}\n\n.services-heading {\n  margin-bottom: 15px;\n  color: #000000;\n  font-weight: bold;\n}\n\n.checkbox-list {\n  text-align: left;\n  margin: 0 auto;\n}\n\n.service-checkbox {\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.service-checkbox input {\n  margin-right: 10px;\n}\n\n.button-container {\n  margin-top: 30px;\n}\n\n.select-drone-payload-button {\n  font-size: 18px;\n  padding: 10px 20px;\n}\n/* end  services page css */\n\n/* Drone payload page */\n.drone-payload-card {\n  background-color: #c3c7c9;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex; /* Use flexbox for centering */\n  flex-direction: column; /* Stack items vertically */\n  align-items: center; /* Center items horizontally */\n}\n\n.drone-payload-heading {\n  color: #000000;\n  font-weight: bold;\n  text-align: center;\n}\n\n.payload-textarea {\n  width: 100%; /* Full width of the card */\n  height: 300px;\n  resize: none;\n  background-color: #f8f9fa;\n  box-sizing: border-box; /* Include padding and border in width calculation */\n}\n\n.word-count {\n  position: absolute;\n  bottom: 135px;\n  right: 10px; /* Adjust to prevent overflow on smaller screens */\n  font-size: 12px;\n  color: gray;\n  background-color: white;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n\n.submit-btn {\n  width: 50%;\n  margin-top: 20px;\n  padding: 10px 20px;\n  font-size: 1.2rem;\n}\n\n/* Center the form submit button */\n.text-center {\n  text-align: center;\n}\n\n.alert {\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  .drone-payload-heading {\n    font-size: 1.5rem;\n  }\n\n  .submit-btn {\n    width: 100%;\n  }\n}\n\n/* Add custom styling for the skip button */\n.custom-skip-btn { \n  height: 105px;            /* Text color */\n  margin-top: 20px;\n}\n\n\n/* End Drone payload page */\n\n/* Terms and condations */\n.terms-container {\n  background-color: #c3c7c9;\n  padding: 20px;\n  min-height: 100vh; /* Make sure it takes full height */\n}\n\n.terms-heading {\n  color: #000000;\n  font-weight: bold;\n  margin-bottom: 20px; /* Space below heading */\n}\n\n.terms-checkbox {\n  display: flex;\n  margin-bottom: 20px; /* Space below checkbox */\n}\n\n.button-container {\n  display: flex;\n  justify-content: center; /* Center the button */\n}\n\n.loading-spinner {\n  position: fixed; \n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* end Terms and condations */\n/* Buttons styling */\n.btn-primary {\n  background-color: #FC5C65; /* Primary button color */\n  color: rgb(0, 0, 0);       /* Text color */\n  font-size: large;\n  border-radius: 40px;       /* Make corners rounded */\n  border: none;              /* Remove border */\n  outline: none;             /* Remove outline */\n  cursor: pointer;           /* Change cursor to pointer */\n  transition: background-color 0.3s ease; /* Smooth transition */\n  padding: 25px;\n}\n\n.btn-primary:hover {\n  background-color: #FC5C65; /* Darker shade for hover */\n  color: rgb(0, 0, 0);       /* Maintain text color */\n}\n\n.btn-primary:focus,\n.btn-primary:active {\n  background-color: #FC5C65; /* Maintain color on focus and active */\n  color: rgb(0, 0, 0);       /* Maintain text color */\n  outline: none;             /* Remove blue outline */\n}\n\n/* Fixing the disabled state to keep the color consistent */\n.btn-primary:disabled {\n  background-color: #FC5C65; /* Maintain button color when disabled */\n  color: rgb(0, 0, 0);       /* Maintain text color */\n  opacity: 0.7;              /* Slightly faded to indicate disabled */\n  cursor: not-allowed;       /* Change cursor to not-allowed */\n}\n\n/* Secondary Button */\n.btn-secondary {\n  background-color: #6c757d; /* Secondary button color */\n  color: #070707;            /* Text color */\n  border-radius: 40px;       /* Make corners rounded */\n  border: none;              /* Remove border */\n  outline: none;             /* Remove outline */\n  cursor: pointer;           /* Change cursor to pointer */\n  transition: background-color 0.3s ease; /* Smooth transition */\n  padding: 25px;\n  font-size: large;\n}\n\n.btn-secondary:hover {\n  background-color: #5a6268; /* Darker shade for hover */\n}\n\n.btn-secondary:focus,\n.btn-secondary:active {\n  background-color: #6c757d; /* Maintain color on focus and active */\n  color: #0b0b0b;            /* Maintain text color */\n  outline: none;             /* Remove blue outline */\n}\n\n.btn-secondary:disabled {\n  background-color: #6c757d; /* Maintain button color when disabled */\n  color: #070707;            /* Maintain text color */\n  opacity: 0.7;              /* Slightly faded to indicate disabled */\n  cursor: not-allowed;       /* Change cursor to not-allowed */\n}\n\n\n.container{\n  background-color:rgb(201, 203, 207);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
